<template>
  <div v-if="showDialog" class="modal fade show" tabindex="-1"
       style="display: block; background-color: rgba(0,0,0,0.5)"
       @click.self="handleOk">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button type="button" class="btn-close" @click="handleOk"></button>
        </div>
        <div class="modal-body">
            <span >{{ body }}</span>
        </div>
        <div class="modal-footer">
          <button type="button" class="ms-4 btn btn-outline-primary" @click="handleOk" >
            <i class="fas fa-check"></i> OK
          </button>
        </div>
      </div>
    </div>
  </div>
</template>


<script setup>
import {getCurrentInstance, nextTick, onMounted, ref, useTemplateRef, watch} from 'vue'
import {addIcon} from "@/plugins/fontawesome";
import {
  faCheck,
  faTimes
} from '@fortawesome/pro-solid-svg-icons';


addIcon(faCheck, faTimes);


// Input value state
const showDialog = ref(false)
const title = ref("Input")
const body = ref("Really?")

const closePromise = ref(false)


// Reset input value when dialog opens
const setupDialog = (dialogTitle, dialogBody, resultPromiseFunction) => {
  closePromise.value = resultPromiseFunction;
  title.value = dialogTitle;
  body.value = dialogBody;
  showDialog.value = true;
}

// Handle OK button click
const handleOk = () => {
  showDialog.value = false;
  if (closePromise.value) {
    closePromise.value(true);
    closePromise.value = false;
  }
}


// Handle ESC key
if (typeof window !== 'undefined') {
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && showDialog) {
      handleOk()
    }
  })
}

defineExpose({
  setupDialog
})
</script>

<style scoped>
.modal.show {
  display: block;
}
</style>